import { Component, Input } from '@angular/core';
import { ClientDataRequestTypeEnum } from 'src/app/models/ClientDataEnums';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'client-data-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
  standalone: false,
})
export class ClientDataCardViewComponent {
  public dictionaryRequestStatus = DictionaryRequestStatus;

  @Input() requests: app.models.GetClientDataRequest[];
  @Input() props: app.models.DynamicPropsDictionary;

  @Input() detailsHandler: any;

  typesEnum = ClientDataRequestTypeEnum;

  constructor() {}
}
